export default function (key = null) {
  const data = {
    dont_show_again_setup: '_dsas',
    dont_show_again_university_news: '_dsaun'
  }

  if (!helpers.isEmpty(key)) {
    return data[key];
  }

  return key;
}